import React from 'react';
import { motion } from 'framer-motion';
import { Crown, Scissors, MapPin } from 'lucide-react';
const pillars = [{
  icon: Crown,
  title: 'Experiencia Premium',
  desc: 'No es solo un corte, es un momento para vos. Ambiente exclusivo y atención personalizada.'
}, {
  icon: Scissors,
  title: 'Barberos Profesionales',
  desc: 'Un equipo en constante formación, dominando las últimas tendencias y técnicas clásicas.'
}, {
  icon: MapPin,
  title: 'Ubicados en Montevideo',
  desc: 'Tu barbería de confianza en un punto accesible de la ciudad. Vení a conocernos.'
}];
export function WhyUs() {
  return <section className="py-24 bg-dark-surface border-y border-white/5" data-id="element-140">
      <div className="container mx-auto px-6" data-id="element-141">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-12" data-id="element-142">
          {pillars.map((pillar, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: index * 0.2
        }} className="flex flex-col items-center text-center" data-id="element-143">
              <div className="w-16 h-16 rounded-full bg-dark flex items-center justify-center mb-6 border border-gold/20 shadow-[0_0_15px_rgba(201,168,76,0.1)]" data-id="element-144">
                <pillar.icon className="text-gold w-8 h-8" data-id="element-145" />
              </div>
              <h3 className="text-xl font-bold mb-3" data-id="element-146">{pillar.title}</h3>
              <p className="text-gray-400 text-sm leading-relaxed max-w-xs" data-id="element-147">
                {pillar.desc}
              </p>
            </motion.div>)}
        </div>
      </div>
    </section>;
}